import { type ConsentManager, PERMISSION_VALUE } from '@vgtv/consent-manager';

import { resolveWithTimeout } from 'utils/async';

const DEFAULT_TIMEOUT_IN_MILLISECONDS = 2500;

export const getAdPermission = (consentManager: ConsentManager) => {
    return resolveWithTimeout({
        promise: consentManager.getPermissionAsync('CMP:advertising'),
        fallback: PERMISSION_VALUE.DENIED,
        timeout: DEFAULT_TIMEOUT_IN_MILLISECONDS,
    });
};
